import { generateAuthorizationHeader } from './generateAuthorizationHeader';
import { gracefulFetch } from './gracefulFetch';
import { postEvent } from './postEvent';
import { routes } from '../constants/constants';

interface Props {
  uuid: UUID;
}

export const getCaseInfo = async ({ uuid }: Props) => {
  let response: Response | null = null;

  if (!uuid) {
    if (window.location.pathname !== routes.HOME) {
      window.location.pathname = routes.HOME;
    }
    return;
  }

  try {
    const headers = await generateAuthorizationHeader();

    response = await gracefulFetch({
      fetch: async () =>
        fetch(
          `${process.env.REACT_APP_API}/cases/${uuid}/case_info?source=jumppage`,
          {
            cache: 'no-store',
            method: 'GET',
            headers
          }
        )
    });
  } catch (error) {
    postEvent({
      uuid,
      event: 'WEB.JUMP.ERROR',
      details: {
        info: 'getCaseInfo',
        error: error.message || error,
        stack: error.stack
      }
    });
  }

  if (response && response.ok) {
    const json = await response.json();
    return json;
  } else {
    postEvent({
      uuid,
      event: 'WEB.JUMP.ERROR',
      details: {
        info: 'getCaseInfo',
        status: response && response.status
      }
    });
  }
};
